import React from "react";
import { Label } from "reactstrap";

const AcctAmortStatus = ({ amort, acct }) => {
	// Compute how much is still owed:
	let balance =
		amort.int2Pay +
		amort.princ2Pay +
		(amort.salesTax || 0.0) -
		(amort.intPaid || 0.0) -
		(amort.princPaid || 0.0) -
		(amort.salesTaxPaid || 0.0);
	balance = parseFloat(balance).toFixed(2);
	balance = parseFloat(balance);
	// Remaining principal-only balance:
	const prnBalance = parseFloat(
		parseFloat(amort.princ2Pay - (amort.princPaid || 0)).toFixed(2)
	);

	// Parse both dates into timestamps for accurate comparison:
	const dueTs = amort.dueDate ? new Date(amort.dueDate).getTime() : null;
	const nextTs = acct.nextDueDate ? new Date(acct.nextDueDate).getTime() : null;

	amort.isDeferred === false;

	return (
		<>
			{
				// 1) Show “Postpone” button if nextDueDate === dueDate and not yet deferred
				(dueTs !== null &&
					nextTs !== null &&
					dueTs === nextTs &&
					!amort.isDeferred && <h6>Next Due Date</h6>) ||
					// 2) If already deferred
					(amort.isDeferred && (
						<Label style={{ color: "blue", fontSize: "14px" }}>
							<h6>Postponed</h6>
						</Label>
					)) ||
					// 3) If fully paid
					(balance === 0.0 && (
						<Label style={{ color: "green", fontSize: "14px" }}>
							<h6>Full Paid</h6>
						</Label>
					)) ||
					// 4) If paid off principal early (no principal left but some interest/tax remains)
					(prnBalance === 0 && balance > 0 && (
						<Label style={{ color: "green", fontSize: "14px" }}>
							<h6>Paid Early</h6>
						</Label>
					)) ||
					// 5) If past due (balance > 0 AND dueDate ≤ nextDueDate)
					(prnBalance > 0 &&
						dueTs !== null &&
						nextTs !== null &&
						dueTs <= nextTs &&
						amort.isDeferred !== true && (
							<Label style={{ color: "red", fontSize: "14px" }}>
								<h6>Past Due</h6>
							</Label>
						))
			}
		</>
	);
};

export default AcctAmortStatus;
